import { CondenserAnimatic } from '@crossnokaye/ux-animatics';

import { Ref } from '@repo/sdk/models/components';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/constants';
import { getLabel } from '@/features/equipment-browser/animatics/helpers';
import { getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticCondenser = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const fanOnRefs = config.specificAnimaticConfig?.condenser?.fanOnRefs ?? [];
  const fanLabels = config.specificAnimaticConfig?.condenser?.fanLabels ?? [];
  let fanOnValues: boolean[] = [];
  if (fanOnRefs.length === 0) {
    fanOnValues = [false];
  } else {
    fanOnValues = fanOnRefs.map((ref: Ref) => getRefValue(ref) as boolean);
  }
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  const scale = fanOnValues.length === 2 || fanOnValues.length === 3 ? 1.2 : 1;

  return (
    <ScaledAnimatic className={className} scaleX={scale} scaleY={scale}>
      <CondenserAnimatic
        fanOn={fanOnValues}
        fanLabels={fanLabels}
        label={primaryLabel?.text}
        state={state}
      />
    </ScaledAnimatic>
  );
};
